import React, { useContext } from "react";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Provider/AuthContext";
import Button from "../components-ui/Button/Button";

export default function Header({ onClick, color }) {
  const {
    nome_usuario,
    versaoApp,
    appNome,
    appLogo,
    idTipoUsuario,
    atualizarVersao,
    setAtualizarVersao,
  } = useContext(AuthContext);

  return (
    <header
      className={styles.header}
      style={
        color === "1"
          ? { backgroundColor: "#dbddd0" }
          : { backgroundColor: "#fff" }
      }
    >
      <div className={styles.logo_container}>
        {idTipoUsuario !== 5 ? (
          <>
            <input
              type="checkbox"
              className={styles.menu}
              id="check"
              onClick={onClick}
            />
            <label htmlFor="check" className={styles.iconMenu}>
              <i className="fas fa-bars"></i>
            </label>
          </>
        ) : null}

        <div className={styles.logo}>
          <img src={"../../public/assets/logo.png"} alt="Logotipo" />
          <strong>
            APP {appNome} - V. {versaoApp}
            {atualizarVersao && (
              <div className={styles.container_novaVersao}>
                Existe uma nova versão, deslogue para atualizar!
              </div>
            )}
          </strong>
        </div>
      </div>
      <div className={styles.profile}>
        <span>
          Bem Vindo
          {/* to={`${validationRoute()}/atualizar-usuario`} */}
          <Link to="atualizar-usuario">
            <strong title="Atualizar Usuario">{nome_usuario}</strong>
            {/* <i className="fas fa-pencil-alt"></i> */}
          </Link>
        </span>
        <img src="/assets/user.png" alt="LogoProfile" />
      </div>
    </header>
  );
}
